// Note: The first file of a module here, must also register the module

import "./create-organisation-campaign.component";
import "./organisation-overview-card.component";
import "./result.component";
import "./result-export.component";
import "./update-leader-dialog.component";
